import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from '@studiobuki/web-core/lib/card';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DialogsModule } from '@studiobuki/web-core/lib/dialogs';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { OrderPageComponent } from './order-page.component';
import { AsideModule } from './components/aside/aside.module';
import { BlockSnsCardComponent } from './components/block-sns-card/block-sns-card.component';
import { FinalComponent } from './components/final/final.component';
import { FooterModule } from './components/footer/footer.module';
import { HeaderModule } from './components/header/header.module';
import { MainModule } from './components/main/main.module';
import { SectionFullComponent } from './components/section-full/section-full.component';
import { SectionLeftComponent } from './components/section-left/section-left.component';
import { SectionRightComponent } from './components/section-right/section-right.component';

@NgModule({
  declarations: [
    OrderPageComponent,
    SectionLeftComponent,
    SectionRightComponent,
    FinalComponent,
    SectionFullComponent,
    BlockSnsCardComponent,
  ],
  imports: [
    CommonModule,
    HeaderModule,
    MainModule,
    FooterModule,
    AsideModule,
    AngularSvgIconModule,
    DialogsModule,
    CardModule,
    ButtonModule,
  ],
})
export class OrderPageModule {}
